import React from 'react';
import Slide, { SlideBody, SlideNextButton, SlidePreviousButton } from '../base/Slide';
import cx from 'classnames'

const DemoSlide = () => {
  return (
    <section className="section-demo">
      <h1 className="text-weight-light sp-xs-top-3 sp-xs-bottom-2 text-accent">Slide</h1>
      <div className="row">
        <div className="col-md-12">
          <Slide className="slide-absolute">
            <SlidePreviousButton>
              <i className="fa fa-angle-left" />
            </SlidePreviousButton>
            <SlideBody>
            {
              [...Array(15).keys()].map(i => {
                return (
                  <div
                    key={i}
                    className={cx("slide-item", {
                    'bg-primary': i % 3 === 0,
                    'bg-success': i % 3 === 1,
                    'bg-warning': i % 3 === 2,
                  })}>
                    { i }
                  </div>
                )
              })
            }
            </SlideBody>
            <SlideNextButton>
              <i className="fa fa-angle-right" />
            </SlideNextButton>
          </Slide>
        </div>
      </div>
    </section>
  );
};

DemoSlide.displayName = 'DemoSlide';

export default DemoSlide;



/** WEBPACK FOOTER **
 ** ./src/components/demo/DemoSlide.js
 **/